import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { AiOutlineUser, AiOutlineShopping, AiOutlineProfile  } from 'react-icons/ai';
import { BiCategory } from "react-icons/bi";

import { FiMenu } from 'react-icons/fi';
import Alluser from './User';
import Allproduct from './Product';
import Category from "./Category";
import Order from "../User/Order";
import Profile from '../Auth/Profile';
import { logOut } from '../../redux/userslice';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../ApiCheck/Loader';

function Sidebar() {
  const [content, setContent] = useState('user');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 900) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };
    
    handleResize()
    
  }, []);

  const handleContentChange = (selectedContent) => {
    if(selectedContent !== content){
      setLoading(true); 
      setContent(selectedContent);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    dispatch(logOut());
  };

  useEffect(() => {
    if (content) {
      setLoading(false); 
    }
  }, [content]);

  return (
    <div className="d-flex">
      <div
        className={`bg-light p-3  ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}
        style={{ minHeight: '100vh' }}
      >
        <Button variant="light" onClick={toggleSidebar} className="mb-3">
          <FiMenu size={24} />
        </Button>
        {isSidebarOpen && <p className="fw-bold mb-3">{user.email}</p>}
        <ul className="list-unstyled">
          <li
            className={`d-flex align-items-center p-2 rounded ${content === 'user' ? 'bg-secondary text-light' : 'text-dark'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => handleContentChange('user')}
          >
            <AiOutlineUser size={20} className="ms-2" />
            {isSidebarOpen && 'User'}
          </li>
          <li
            className={`d-flex align-items-center p-2 rounded ${content === 'product' ? 'bg-secondary text-light' : 'text-dark'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => handleContentChange('product')}
          >
            <AiOutlineShopping size={20} className="ms-2" />
            {isSidebarOpen && 'Product'}
          </li>
          <li
            className={`d-flex align-items-center p-2 rounded ${content === 'category' ? 'bg-secondary text-light' : 'text-dark'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => handleContentChange('category')}
          >
            <BiCategory  size={20} className="ms-2" />
            {isSidebarOpen && 'category'}
          </li>
          <li
            className={`d-flex align-items-center p-2 rounded ${content === 'order' ? 'bg-secondary text-light' : 'text-dark'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => handleContentChange('order')}
          >
            <BiCategory  size={20} className="ms-2" />
            {isSidebarOpen && 'Order'}
          </li>
          <li
            className={`d-flex align-items-center p-2 rounded ${content === 'profile' ? 'bg-secondary text-light' : 'text-dark'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => handleContentChange('profile')}
          >
            <AiOutlineProfile size={20} className="ms-2" />
            {isSidebarOpen && 'Profile'}
          </li>
        </ul>
        {isSidebarOpen && (
          <div className="mt-auto">
            <Button variant="danger" onClick={logout} className="w-100">
              Logout
            </Button>
          </div>
        )}
      </div>
      <div className={`flex-grow-1 p-4 ${isSidebarOpen ? 'ms-5' : 'ms-3'}`} style={{ transition: 'margin-left 0.3s ease' }}>
        {loading ? (
          <Loader />
        ) : (
          <>
            {content === 'user' && <Alluser />}
            {content === 'product' && <Allproduct />}
            {content === 'category' && <Category />}
            {content === 'order' && <Order />}
            {content === 'profile' && <Profile />}
          </>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
